///<reference types="chrome"/>
//// Remove chrome import
import { AfterViewInit, Component, OnInit, ViewChild, EventEmitter } from '@angular/core';
import { Global } from "../../classes/global";
import { UserService } from "../../services/user/user.service";
import { Router, ActivatedRoute } from '@angular/router';
import { Title, Meta } from '@angular/platform-browser';
import { NeedAuthorize } from "../../classes/needAuthorize";
import { SaleRecordService } from "../../services/saleRecord/sale-record.service";
import { MerchantService } from "../../services/merchant/merchant.service";
import { ToastrService } from 'ngx-toastr';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ElementRef } from '@angular/core';

import * as _ from 'lodash';
import { FulfillService } from '../../services/fulfill/fulfill.service';
import { ViewEncapsulation } from '@angular/core';
import { map, timeout, catchError } from 'rxjs/operators';

import {
  HttpClient,
  HttpEventType,
} from "@angular/common/http";
import { LogTimeService } from "../../services/log-time/log-time.service";
import { UploadDesignService } from "../../services/upload-design.service";

@Component({
  selector: 'app-orders',
  templateUrl: './orders-v2.component.html',
  styleUrls: ['./orders-v2.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OrdersV2Component extends NeedAuthorize {
  queryType: number = 1;
  availablePrintConfig: any = {
    printServices: []
  };
  blueprints = [];
  saleRecordTypes = ['POD', 'Physical'];
  query: any = {
    purchaseDate: '',
    shipDueDate: '',
    sourceOrderId: '',
    customerName: '',
    asin: '',
    sku: '',
    destinationOrderId: '',
    trackingNumber: '',
    note: '',
    merchantIds: '',
    merchantGroupIds: '',
    wantedPrintService: '',
    pageSize: 30,
    pageNumber: 1,
    sortBy: 'CreatedTime',
    sortType: 'Desc',
    saleRecordType: undefined
  };

  sellerCheck: any = {
    sourceImage: '',
    suggestProducts: [],
    destinationProductLinkText: "",
    downloadLink: [],
    availableDesigners: [],
    selectedDesigner: null,
  };
  isLoadingDesigners = false;

  saleRecords = [];
  groupedSaleRecords = [];
  totalItem = 0;
  mergeSuggestions: { [key: string]: any[] } = {};
  merchants = [];
  depopMerchants = [];
  tiktokMerchants = [];
  etsyMerchants = [];
  merchantGroups = [];
  temptPreviewImages = [];
  uploadToMerchantGroupId = '';
  uploadToMerchantId = '';
  checkAll = false;
  sinceOrderId = '';

  printifyExport: any = {
    providerId: '',
    productId: ''
  }
  printifyProviders = [];
  printifyProducts = [];
  printwayPlaces = [];
  saleRecordLogs: any = [];
  quickFilters = [
    'isNeedFindLink',
    'isNeedSellerCheck',
    'isNeedFulfill',
    'isNeedShip',
    'isNeedAddTrackToAccount',
    'isFollowTrack',
    'isDone',
    'isNoticed',
    'isWarningLateTrack',
    'isWarningLateDelivery',
    'isPrintLogisticNoTrack'
  ];

  // Lenful properties
  availableLenfulProducts: any[] = [];
  availableLenfulVariations: any[] = [];

  productLinkSaleRecord: any;
  deletedSaleRecord: any = {
    productName: ''
  };

  uploadImportFileProgress = 1;
  importMessages = [];

  progressStates = [
    { name: 'Cần Seller Check', value: 0 },
    { name: 'Cần Xác Minh Thêm', value: 5 },
    { name: 'Cần Design', value: 10 },
    { name: 'Cần Fulfill', value: 20 },
    { name: 'Đợi Tracking', value: 30 },
    { name: 'Cần Trả Track TK', value: 35 },
    { name: 'Đang Theo Dõi Tracking', value: 40 },
    { name: 'Done', value: 50 },
  ];

  filterCount: any = {
  };

  bestPrintCareLineShips = [
    'standard',
    'expedite',
    'priority',
    'vip',
    'express'
  ];

  @ViewChild('exportPrinityShirtModal', { static: false })
  private exportPrinityShirtModal: NgbModalRef;
  @ViewChild('productLinkModal', { static: false })
  private productLinkModal: NgbModalRef;
  @ViewChild('deleteSaleRecordModal', { static: false })
  private deleteSaleRecordModal: NgbModalRef;
  @ViewChild('importSaleRecordModal', { static: false })
  private importSaleRecordModal: NgbModalRef;

  @ViewChild('importSaleRecordTiktokModal', { static: false })
  private importSaleRecordTiktokModal: NgbModalRef;

  @ViewChild('productLinkInput')
  productLinkInput: ElementRef;

  desImages = '';
  preparedIgnoreProduct: any;
  openConfirmAction: EventEmitter<string> = new EventEmitter<string>();
  openConfirmBuyApiAction: EventEmitter<string> = new EventEmitter<string>();
  openConfirmStartDesModal: EventEmitter<string> = new EventEmitter<string>();
  openProductLinkModalEvent: EventEmitter<string> = new EventEmitter<string>();
  ignoreDesTotallyEvent: EventEmitter<string> = new EventEmitter<string>();

  confirmBuyApiMessage = "";
  timerRunning = false;

  printLogisticProducts = [];
  burgerPrintProducts = [];

  buyApiAction: any;
  constructor(protected router: Router,
    protected userService: UserService,
    protected titleService: Title,
    public global: Global,
    private saleRecordService: SaleRecordService,
    private merchantService: MerchantService,
    private fulfillService: FulfillService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private activeRoute: ActivatedRoute,
    private http: HttpClient,
    private logTimeService: LogTimeService,
    private uploadDesignService: UploadDesignService) {
    super(router, userService, titleService);

    this.activeRoute.queryParams.subscribe(params => {
      this.queryType = parseInt(params['queryType']);
      this.query.queryType = this.queryType;

      if (this.userData.roles.indexOf('Designer') > -1) {
        this.progressStates = this.progressStates.filter(_ => _.value <= 20);
        this.query.isNeedFindLink = true;
      } else if (this.userData.roles.indexOf('Fulfill') > -1) {
        this.query.isNeedFulfill = true;
        this.query.page = 60;
      } else if (this.userData.roles.indexOf('Support') > -1) {
        //        this.query.isNeedAddTrackToAccount = true;
      }
      this.getMerchants();
      this.getMerchantGroups();
      //this.getPrintifyFulfillConfigs();
      this.querySaleRecords();
      this.getAvailablePrintConfigs();
      this.getBlueprints();
      this.getBurgerPrintProducts();

      //      this.ignoreDesTotallyEvent.subscribe(() => {
      //        this.ignoreDesTotally();
      //      });
    });
  }

  getAvailablePrintConfigs() {
    this.fulfillService.getAvailablePrintConfigs().subscribe
      (data => {
        this.availablePrintConfig = data;
      });
  }

  ngOnInit(): void {
    this.loadLenfulProducts();
  }

  clearFilter(isQueryAlso = true) {
    this.query = {
      purchaseDate: '',
      shipDueDate: '',
      sourceOrderId: '',
      customerName: '',
      asin: '',
      sku: '',
      destinationOrderId: '',
      trackingNumber: '',
      note: '',
      merchantIds: '',
      merchantGroupIds: '',
      pageSize: 30,
      pageNumber: 1,
      wantedPrintService: '',
      sortBy: 'CreatedTime',
      sortType: 'Desc',
      saleRecordType: undefined
    };

    for (var i = 0; i < this.quickFilters.length; i++) {
      var filter = this.quickFilters[i];
      this.query[filter] = false;
    }

    if (this.userData.roles.indexOf('Designer') > -1 || this.userData.roles.indexOf('Designer Online') > -1) {
      this.query.isNeedFindLink = true;
    } else if (this.userData.roles.indexOf('Fulfill') > -1) {
      //      this.query.isNeedFulfill = true;
      this.query.page = 60;
    } else if (this.userData.roles.indexOf('Support') > -1) {
      //      this.query.isNeedAddTrackToAccount = true;
    }

    if (isQueryAlso) {
      this.querySaleRecords();
    }
  }

  querySaleRecords(page = undefined) {
    if (page != undefined) {
      this.query.pageNumber = page;
    }
    this.global.pageLoading = true;
    this.saleRecordService.query(this.query).subscribe(data => {

      this.saleRecords = data.items;
      this.totalItem = data.total;

      // Group sale records by SourceOrderId
      this.groupedSaleRecords = this.groupSaleRecordsByOrder(this.saleRecords);

      // Load merge suggestions for all sale records
      this.loadMergeSuggestions();

      // Debug grouping (remove in production)
      // this.debugGrouping();

      this.global.pageLoading = false;
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

      this.filterCount = data.filterCount;
    });
  }

  loadMergeSuggestions() {
    if (this.saleRecords.length === 0) {
      return;
    }

    const orderItemIds = this.saleRecords.map(record => record.orderItemId);
    this.saleRecordService.getMergeSuggestions(orderItemIds).subscribe(
      data => {
        this.mergeSuggestions = data;
      },
      error => {
        console.warn('Could not load merge suggestions:', error);
        this.mergeSuggestions = {};
      }
    );
  }

  hasMergeSuggestions(record: any): boolean {
    return this.mergeSuggestions[record.orderItemId] && this.mergeSuggestions[record.orderItemId].length > 0;
  }

  groupSaleRecordsByOrder(saleRecords: any[]): any[] {
    const grouped = {};
    const groupOrder = []; // Track the order of groups as they first appear

    // Group records by SourceOrderId while preserving the original server order
    saleRecords.forEach(record => {
      const orderId = record.sourceOrderId;
      if (!grouped[orderId]) {
        grouped[orderId] = {
          orderInfo: {
            sourceOrderId: record.sourceOrderId,
            customerName: record.customerName,
            customerNote: record.customerNote,
            isTeamFulfill: record.isTeamFulfill,
            customerAddress: this.getCustomerAddressParts(record),
            createdDateString: record.createdDateString,
            createdTimeString: record.createdTimeString,
            sourceOrderType: record.sourceOrderType,
            isPrepaidLabel: record.isPrepaidLabel,
            merchantName: record.merchantName,
            channel: record.channel,
            sellerName: record.sellerName,
            designerName: record.designerName,
            desPoint: record.desPoint,
            currentlyDesign: record.currentlyDesign,
            isScamWarning: record.isScamWarning
          },
          lineItems: []
        };
        groupOrder.push(orderId); // Track the order of first appearance
      }
      grouped[orderId].lineItems.push(record);
    });

    // Convert to array preserving the original server order for both groups and line items
    return groupOrder.map(orderId => grouped[orderId]);
  }

  getCustomerAddress(record: any): string {
    const addressParts = [];
    if (record.streetAddress) addressParts.push(record.streetAddress);
    if (record.streetAddress2) addressParts.push(record.streetAddress2);
    if (record.city) addressParts.push(record.city);
    if (record.state) addressParts.push(record.state);
    if (record.zipCode) addressParts.push(record.zipCode);
    return addressParts.join(', ');
  }

  getCustomerAddressParts(record: any): any {
    return {
      streetAddress: record.streetAddress || '',
      streetAddress2: record.streetAddress2 || '',
      city: record.city || '',
      state: record.state || '',
      zipCode: record.zipCode || ''
    };
  }

  // Debug method to check grouping
  debugGrouping() {
    console.log('Original saleRecords count:', this.saleRecords.length);
    console.log('Grouped saleRecords count:', this.groupedSaleRecords.length);
    this.groupedSaleRecords.forEach((group, index) => {
      console.log(`Group ${index}: Order ${group.orderInfo.sourceOrderId} has ${group.lineItems.length} line items`);
    });
  }

  getMerchants() {
    this.merchantService.getGrantedMerchants(this.query.merchantGroupIds).subscribe(data => {
      this.merchants = data;

      this.depopMerchants = _.filter(data, i => i.merchantType == 5);
      this.tiktokMerchants = _.filter(data, i => i.merchantType == 2);
      this.etsyMerchants = _.filter(data, i => i.merchantType == 4);
    });
  }

  getMerchantGroups() {
    this.merchantService.getGrantedMerchantGroups().subscribe(data => {
      this.merchantGroups = data;
    });
  }

  updateMerchantGroupFilter() {
    // Auto-select items that start with the selected item if it doesn't contain ' - '
    if (this.query.merchantGroupIds && this.query.merchantGroupIds.length > 0) {
      const selectedGroups = new Set(this.query.merchantGroupIds);
      const groupsToAdd = new Set<string>();

      // Find groups to add
      selectedGroups.forEach(selectedId => {
        const selectedGroup = this.merchantGroups.find(g => g.id === selectedId);
        if (selectedGroup && !selectedGroup.name.includes(' - ')) {
          // Find all groups that start with the selected group's name
          this.merchantGroups.forEach(group => {
            if (group.name.startsWith(selectedGroup.name) &&
              group.id !== selectedId &&
              !selectedGroups.has(group.id)) {
              groupsToAdd.add(group.id);
            }
          });
        }
      });

      // Add new groups to selection if any found
      if (groupsToAdd.size > 0) {
        this.query.merchantGroupIds = [...selectedGroups, ...groupsToAdd];
      }
    }

    this.getMerchants();
    this.query.merchantIds = '';
    this.querySaleRecords(1);
  }

  updateSingleValue(record, type, value) {

    if (type == "Note") {
      record.note = value;
    } else if (type == "DestinationOrderId") {
      record.destinationOrderId = value;
    } else if (type == "ProductPrice") {
      record.productPrice = value;
    } else if (type == "OrderPrice") {
      record.orderPrice = value;
    } else if (type == "TrackingNumber") {
      record.trackingNumber = value;
    } else if (type == "OrderRefund") {
      record.orderRefund = value;
    } else if (type == "IsNeedReorder") {
      record.isNeedReorder = !record.isNeedReorder;
    } else if (type == "IsNeedFindLink") {
      record.isNeedFindLink = !record.isNeedFindLink;
    } else if (type == "IsCanceled") {
      record.isCanceled = !record.isCanceled;
    } else if (type == "IsNoticed") {
      record.isNoticed = !record.isNoticed;
    } else if (type == "IsDeleted") {
      record.isDeleted = value;
    } else if (type == "ProgressState") {
      record.progressState = value;
    } else if (type == "DesPoint") {
      record.desPoint = value;
    } else if (type == "DesPointExplain") {
      record.desPointExplain = value;
    } else if (type == "DesPointExplain") {
      record.desPointExplain = value;
    } else if (type == "Des") {
      record.destinationProductLinkText = value;
      record.destinationProductLink = value;
      record.destinationProductThumbnail = value;
    } else if (type == "WantedPrintService") {
      record.wantedPrintService = value;
    }

    this.saleRecordService.updateSingleValue(record, type).subscribe(data => {
      for (var i = 0; i < this.saleRecords.length; i++) {

        var model = _.find(data, o => o.orderItemId === this.saleRecords[i].orderItemId);
        if (model == undefined || model.length === 0) {
          continue;
        }
        var oldSeller = this.saleRecords[i].sellerName;
        var oldDesigner = this.saleRecords[i].designerName;

        this.saleRecords[i] = model;

        if (!model.sellerName) {
          this.saleRecords[i].sellerName = oldSeller;
        }
        if (!model.designerName) {
          this.saleRecords[i].designerName = oldDesigner;
        }

      }

      // Update the grouped data structure
      this.groupedSaleRecords = this.groupSaleRecordsByOrder(this.saleRecords);

      this.getFilterCount();
      if (type == "Des") {
        this.toastr.success("Cập nhật Des thành công");
      }
    },
      error => {
        this.toastr.error("Có lỗi xảy ra khi cập nhật thông tin đơn hàng, xin vui lòng báo cho Admin");
      });
  }


  updateNoteForSellerCheck(record, value) {
    record.note = this.sellerCheck.sourceProduct.note;
    this.updateSingleValue(record, 'Note', this.sellerCheck.sourceProduct.note);
  }

  updateDesForSellerCheck(record, value) {
    if (this.userData.roles.indexOf('Fulfill') === -1 || record.progressState !== 20) {
      return;
    }

    record.destinationProductLinkText = value;
    this.updateSingleValue(record, 'Des', this.sellerCheck.destinationProductLinkText);
  }

  getFilterCount() {
    this.saleRecordService.getFilterCount().subscribe(data => {
      this.filterCount = data;
    });
  }

  onCoppied(record, type) {
    for (var i = 0; i < this.saleRecords.length; i++) {
      this.saleRecords[i].sourceOrderIdCoppied = false;
      this.saleRecords[i].customerNameCoppied = false;
      this.saleRecords[i].asinCoppied = false;
      this.saleRecords[i].destinationOrderIdCoppied = false;
      this.saleRecords[i].productPriceCoppied = false;
      this.saleRecords[i].orderPriceCoppied = false;
      this.saleRecords[i].trackingNumberCoppied = false;
      this.saleRecords[i].wantedPrintServiceCoppied = false;
    }

    if (type === "sourceOrderId") {
      record.sourceOrderIdCoppied = true;
    }
    if (type === "customerName") {
      record.customerNameCoppied = true;
    }
    if (type === "asin") {
      record.asinCoppied = true;
    }
    if (type === "destinationOrderId") {
      record.destinationOrderIdCoppied = true;
    }
    if (type === "productPrice") {
      record.productPriceCoppied = true;
    }
    if (type === "orderPrice") {
      record.orderPriceCoppied = true;
    }
    if (type === "trackingNumber") {
      record.trackingNumberCoppied = true;
    }
    if (type === "wantedPrintService") {
      record.wantedPrintServiceCoppied = true;
    }

    // Show toast message with 1 second duration
    this.toastr.success('Copied!', '', {
      timeOut: 1000,
      progressBar: false,
      closeButton: false
    });
  }

  reorder(record) {
    this.saleRecordService.reorder(record).subscribe((data) => {
      for (var i = 0; i < this.saleRecords.length; i++) {
        if (this.saleRecords[i].orderItemId != record.orderItemId) {
          continue;
        }

        this.saleRecords.splice(i, 0, data);
        record.isNeedReorder = false;
        break;
      }

      // Update the grouped data structure
      this.groupedSaleRecords = this.groupSaleRecordsByOrder(this.saleRecords);
    });
  }

  onProductLinkCopied() {
    this.toastr.success('copied');
    this.modalService.dismissAll();
  }

  saveProductLink() {
    this.updateSingleValue(this.productLinkSaleRecord, "ProductLink", this.productLinkSaleRecord.destinationProductLink);
    this.modalService.dismissAll();
  }

  confirmDeleteSaleRecord(record) {
    this.deletedSaleRecord = JSON.parse(JSON.stringify(record));
    this.modalService.open(this.deleteSaleRecordModal);
  }

  deleteSaleRecord() {
    this.updateSingleValue(this.deletedSaleRecord, "IsDeleted", true);
    this.modalService.dismissAll();
  }

  toggleQuickFilter(type) {

    for (var i = 0; i < this.quickFilters.length; i++) {
      var filter = this.quickFilters[i];
      if (
        filter == type && this.query[filter] == true && (this.userData.roles.indexOf('Designer') > -1 || this.userData.roles.indexOf('Designer Online') > -1)) {

      } else if (filter == type) {
        this.query[filter] = !this.query[filter];
      } else if (this.quickFilters[i] == type) {
        this.query[filter] = true;
      } else {
        this.query[filter] = false;
      }
    }
    this.querySaleRecords(1);
  };

  getCustomization(customization, index) {
    if (customization == null || customization == '') {
      return '';
    }

    index = index - 1;

    var partSeperate = '';
    var informSeperate = '';
    if (customization.indexOf('====') > -1 || customization.indexOf('>>>') > -1) {
      partSeperate = '====';
      informSeperate = ">>>";
    } else {
      partSeperate = ',';
      informSeperate = ":";
    }

    var parts = customization.split(partSeperate);
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].split(informSeperate).length == 2) {
        parts[i] = parts[i].split(informSeperate)[1].trim();
      } else {
        parts[i] = parts[i].trim();
      }
    }
    if (index > parts.length - 1) {
      return '';
    }
    return parts[index];
  };

  getAllCustomizations(customization) {
    if (customization == null || customization == '') {
      return [];
    }

    var partSeperate = '';
    var informSeperate = '';
    if (customization.indexOf('====') > -1 || customization.indexOf('>>>') > -1) {
      partSeperate = '====';
      informSeperate = ">>>";
    } else {
      partSeperate = ',';
      informSeperate = ":";
    }

    var parts = customization.split(partSeperate);
    var customizations = [];

    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (part) {
        if (part.split(informSeperate).length == 2) {
          var keyValue = part.split(informSeperate);
          customizations.push({
            key: keyValue[0].trim(),
            value: keyValue[1].trim()
          });
        } else {
          customizations.push({
            key: `Custom ${i + 1}`,
            value: part
          });
        }
      }
    }

    return customizations;
  };

  copyOrderData(record) {
    if (record != undefined && (record.streetAddress2 == undefined || record.streetAddress2 == null)) {
      record.streetAddress2 = '';
    }
    let event = new CustomEvent('copySaleRecord', { 'detail': record });
    window.dispatchEvent(event);
  };

  copyHeading(record) {
    let str = 'ASIN: ' + record.asin;
    if (record.sku != undefined && record.sku != null && record.sku !== '') {
      let formatSkuParts = record.sku.split('-');

      if (formatSkuParts.length >= 2) {
        str += ' SKU: ' + formatSkuParts[0] + '-' + formatSkuParts[1];
      } else {
        str = ' SKU: ' + record.sku;
      }
    }
    this.copyStringToClipboard(str);
  };

  openExportPrintifyDialog() {
    this.printifyExport.providerId = '';
    this.printifyExport.productId = '';
    this.modalService.open(this.exportPrinityShirtModal);
  };

  downloadExportFileForPrintify() {
    this.global.pageLoading = true;
    this.modalService.dismissAll();
    this.fulfillService.downloadExportFileForPrintify(this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'text/csv;charset=ASCII;' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "Export-printify.csv";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });
  };

  downloadExportFileForFlashship() {
    this.global.pageLoading = true;
    this.fulfillService.downloadExportFileForFlashship(this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "Export-FlashShip.xlsx";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });

  };

  downloadExportFileForBestPrintCare() {
    this.global.pageLoading = true;
    this.fulfillService.downloadExportFileForBestPrintCare(this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "Best-Print-Care.xlsx";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });
  };

  downloadExportFileForPrintLogistic() {
    this.global.pageLoading = true;
    this.fulfillService.downloadExportFileForPrintLogistic(this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'text/csv;charset=ASCII;' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "Print-Logistic.csv";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });
  };

  downloadExportFileForBeeful() {
    this.global.pageLoading = true;
    this.fulfillService.downloadExportFileForBeeful(this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'text/csv;charset=ASCII;' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "Beeful-Export.csv";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });
  };

  downloadExportFileForBurgerPrint() {
    this.global.pageLoading = true;
    this.fulfillService.downloadExportFileForBurgerPrint(this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'text/csv;charset=ASCII;' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "BurgerPrint-Export.csv";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });
  };

  buyMultipleRecordsByMerchizeApi() {
    this.global.pageLoading = true;
    this.fulfillService.buyMultipleRecordsMerchizeApi(this.saleRecords)
      .subscribe(data => {
        this.handleAfterSubmitApiOrders(data);
      },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByBestPrintCareApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderBestPrintCareApi(this.saleRecords)
      .subscribe(data => {
        this.handleAfterSubmitApiOrders(data);
      },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByPrintifyApi() {
    this.global.pageLoading = true;
    this.fulfillService.buyMultipleRecordsByPrintifyApi(this.saleRecords)
      .subscribe(data => {
        this.handleAfterSubmitApiOrders(data);
      },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  preConfirmBuyApi(printService) {
    var checkRecordCount = 0;

    for (var i = 0; i < this.saleRecords.length; i++) {
      if (this.saleRecords[i].isSelected) {
        checkRecordCount++;
      }
    }

    this.confirmBuyApiMessage = "Bạn có muốn mua " + checkRecordCount + " bản ghi bằng " + printService + "?";
    if (printService == "flashship") {
      this.buyApiAction = this.buyMultipleRecordsByFlashshipApi;
    }
    if (printService == "printify") {
      this.buyApiAction = this.buyMultipleRecordsByPrintifyApi;
    }
    if (printService == "merchize") {
      this.buyApiAction = this.buyMultipleRecordsByMerchizeApi;
    }
    if (printService == "bestPrintCare") {
      this.buyApiAction = this.buyMultipleRecordsByBestPrintCareApi;
    }
    if (printService == "printway") {
      this.buyApiAction = this.buyMultipleRecordsByPrinwayApi;
    }
    if (printService == "beeful") {
      this.buyApiAction = this.buyMultipleRecordsByBeefulApi;
    }
    if (printService == "burgerprint") {
      this.buyApiAction = this.buyMultipleRecordsByBurgerPrintApi;
    }
    if (printService == "lenful") {
      this.buyApiAction = this.buyMultipleRecordsByLenfulApi;
    }
    this.openConfirmBuyApiAction.emit();
  }

  getAvailablePrintWayPlaces() {
    if (!this.sellerCheck.calculatedPrintWaySku) {
      this.printwayPlaces = ['US', 'VN', 'CN', 'UK', 'AU'];
    }
    var places = [
      ...new Set(this.sellerCheck.availablePrintWayConfigs.filter(i => i.sku == this.sellerCheck.calculatedPrintWaySku).map(i => i.madeLocation))
    ];
    this.printwayPlaces = places;

    if (this.printwayPlaces.length == 1) {
      this.sellerCheck.calculatedPrintWayPlace = this.printwayPlaces[0];
    }
  }

  buyMultipleRecordsByPrinwayApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderPrintwayApi(this.saleRecords)
      .subscribe(data => {
        this.handleAfterSubmitApiOrders(data, 'printway');
      },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByBeefulApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderBeefulApi(this.saleRecords)
      .subscribe(data => {
        this.handleAfterSubmitApiOrders(data, 'beeful');
      },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByFlashshipApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderFlashshipApi(this.saleRecords)
      .subscribe(data => {
        this.handleAfterSubmitApiOrders(data, 'flashship');
      },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByBurgerPrintApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderBurgerPrintApi(this.saleRecords)
      .subscribe(data => {
        this.handleAfterSubmitApiOrders(data, 'burgerprint');
      },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  buyMultipleRecordsByLenfulApi() {
    this.global.pageLoading = true;
    this.fulfillService.sendOrderLenfulApi(this.saleRecords)
      .subscribe(data => {
        this.handleAfterSubmitApiOrders(data, 'lenful');
      },
        error => {
          this.toastr.error(error.message);
          this.global.pageLoading = false;
        });
  }

  handleAfterSubmitApiOrders(data, service = '') {
    this.refreshSaleRecordData(data);
    this.global.pageLoading = false;
    if (service == 'flashship') {
      var hasErrorFlashship = false;
      for (var i = 0; i < data.length; i++) {
        if (data[i].destinationOrderId == undefined || data[i].destinationOrderId == '') {
          this.toastr.error("Có lỗi xảy ra: " + data[i].streetAddress);
        }
      }
      return;
    }

    var hasError = false;
    for (var i = 0; i < data.length; i++) {
      if (!data[i]) {
        hasError = true;
        break;
      }
    }

    if (hasError) {
      this.toastr.error("Có lỗi xảy ra với một hoặc nhiều đơn");
    } else {
      this.toastr.success("Đơn đã được gửi sang hệ thống nhà in");
    }
  }

  downloadExportFileForMerchize() {
    this.global.pageLoading = true;
    this.fulfillService.downloadExportFileForMerchize(this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'text/csv;charset=ASCII;' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "Export-Merchize.csv";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });
  };

  downloadExportFileForGeargag() {
    this.global.pageLoading = true;
    this.fulfillService.downloadExportFileForGeargag(this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'text/csv;charset=ASCII;' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "Export-Geargag.csv";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });
  };

  downloadExportFileForPrintWay() {
    this.global.pageLoading = true;
    this.fulfillService.downloadExportFileForPrintWay(this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "Export-PrintWay.xlsx";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });
  };

  downloadExportFileForArtsAdd() {
    this.global.pageLoading = true;
    this.fulfillService.downloadExportFileForArtsAdd(this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'application/octet-stream' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "Export-ArtsAdd.xls";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });
  };

  downloadExportFileForGearment() {
    this.global.pageLoading = true;
    this.fulfillService.downloadExportFileForGearment(this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "Export-Gearment.xlsx";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });
  };

  downloadExportFileForOnePrint() {
    this.global.pageLoading = true;
    this.fulfillService.downloadExportFileForOnePrint(this.saleRecords).subscribe(data => {
      var blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      var url = window.URL.createObjectURL(blob);
      this.global.pageLoading = false;

      var fileLink = document.createElement('a');
      fileLink.href = url;
      fileLink.download = "Export-OnePrint.xlsx";
      fileLink.click();

      fileLink.parentNode.removeChild(fileLink);
    });
  };

  copyStringToClipboard(str) {
    if (str === null || str === undefined || str === '') {
      str = ' ';
    }
    // Create new element
    var el = document.createElement('textarea');
    // Set value (string to be copied)
    el.value = str;
    // Set non-editable to avoid focus and move outside of view
    el.setAttribute('readonly', '');
    document.body.appendChild(el);
    // Select text inside element
    el.select();
    // Copy text to clipboard
    document.execCommand('copy');
    // Remove temporary element
    document.body.removeChild(el);
  };

  toggleCheckAll() {
    for (var i = 0; i < this.saleRecords.length; i++) {
      this.saleRecords[i].isSelected = !this.checkAll;
    }
  };

  openImportSaleRecordModal() {
    this.uploadImportFileProgress = 0;
    this.importMessages = [];
    this.uploadToMerchantGroupId = '';

    if (this.merchantGroups.length == 1) {
      this.uploadToMerchantGroupId = this.merchantGroups[0].id;
      this.uploadToMerchantId = undefined;
    }

    this.modalService.open(this.importSaleRecordModal, { windowClass: "xlModal" });

  }

  uploadImportFile(files) {
    if (this.uploadToMerchantGroupId == '') {
      return;
    }
    this.uploadImportFileProgress = 1;
    const formData = new FormData();

    for (var i = 0; i < files.length; i++) {
      formData.append("file", files[i]);
    }

    this.global.pageLoading = true;
    this.http
      .post("/api/SaleRecord/UploadSaleRecordsViaCsv?uploadToMerchantGroupId=" + this.uploadToMerchantGroupId
        + "&uploadToMerchantId=" + this.uploadToMerchantId,
        formData,
        {
          reportProgress: true,
          observe: "events"
        })
      .subscribe(event => {
        if (event.type == HttpEventType.UploadProgress) {
          this.uploadImportFileProgress = Math.round((100 / event.total) * event.loaded);

        } else if (event.type == HttpEventType.Response) {

          this.uploadImportFileProgress = null;
          this.global.pageLoading = false;

          this.importMessages = [];
          for (let i = 0; i < (<any>event.body).length; i++) {
            const element = event.body[i];
            this.importMessages.push(element.message);
          }
        }
      });
  }

  //Seller Check => Start
  openProductLinkModal(record) {
    // Validate that record has required properties for the new seller check API
    if (!record.orderItemId || !record.sourceOrderId) {
      this.toastr.error("Missing required order information. Please refresh the page and try again.");
      return;
    }

    this.global.pageLoading = true;
    this.saleRecordLogs = [];
    this.sellerCheck = {
      suggestProducts: [],
      destinationProductLinkText: "",
      selectedProduct: {
      },
      availableDesigners: [],
      selectedDesigner: null,
      calculatedBurgerPrintProduct: null
    };
    this.getAvailablePrintLogistics();
    this.temptPreviewImages = [];


    this.saleRecordService.getSellerCheckModel(record).subscribe(data => {
      this.sellerCheck = data;
      this.sellerCheck.currentRecord = record;

      if (this.sellerCheck.suggestProducts.length >= 1 && this.sellerCheck.sourceProduct.progressState >= 20) {
        this.selectSuggestProduct(this.sellerCheck.suggestProducts[0]);
      }

      // Load designers separately if state <= 30
      if (record.progressState <= 30) {
        this.loadAvailableDesigners(record.orderItemId);
      } else {
        // For other states, keep empty list
        this.sellerCheck.availableDesigners = [];
      }

      this.modalService.open(this.productLinkModal, { windowClass: "xlModal" });
      this.genDownloadLinks();
      this.getImageSizes();
      this.getAvailablePrintWayPlaces();

      // Load Printify providers if blueprint is already selected
      if (this.sellerCheck.calculatedPrintifyBlueprintId) {
        this.getPrintifyProviders(this.sellerCheck.calculatedPrintifyBlueprintId);
      }

      // Load Lenful products and variants if needed
      this.loadLenfulProductsAndVariations();
      
      setTimeout(
        () => {
          this.openProductLinkModalEvent.emit(record.sku);
        },
        200);

      this.openProductLinkModalEvent.emit(record.sku);
      this.global.pageLoading = false;
    }, error => {
      this.global.pageLoading = false;
      this.toastr.error("Error loading seller check data: " + (error.error?.message || error.message || "Unknown error"));
    });

    this.saleRecordService.getSaleRecordLog(record).subscribe(data => {
      this.saleRecordLogs = data;
    }, error => {
      console.warn("Could not load sale record logs:", error);
    });

  };

  selectSuggestProduct(suggestProduct) {
    this.sellerCheck.selectedProduct = suggestProduct;
    this.sellerCheck.destinationProductLinkText = suggestProduct.imageLinkText;
    
    // Create preview images with labels from suggestion
    this.createPreviewImagesFromLinks(suggestProduct.demoLinks);
  };

  onDesignSelected(design: any) {
    // Fill the destination product link
    this.sellerCheck.destinationProductLinkText = design.destinationProductLink;

    // Create a product object similar to suggestProduct structure
    const selectedProduct = {
      label: design.productName,
      imageLinkText: design.destinationProductLink,
      demoLinks: design.destinationProductThumbnail
        ? design.destinationProductThumbnail.split('\n').filter(link => link.trim() !== '')
        : []
    };

    // Set as selected product
    this.sellerCheck.selectedProduct = selectedProduct;

    // Create preview images with labels from design search
    this.createPreviewImagesFromLinks(selectedProduct.demoLinks);

    // Generate download links if needed
    this.genDownloadLinks();
  }

  onDesignFilesSelected(designFiles: any[]) {
    // Handle file selection - files are stored for preview only
    // No immediate upload happens here
    console.log('Design files selected:', designFiles);
  }

  onSubmitDesignFiles(designFiles: any[]) {
    // Handle the actual upload with alphabetical naming using DropboxService
    if (designFiles && designFiles.length > 0) {
      this.sellerCheck.uploadProgress = 1;
      
      // Sort files by position (Front, Back, Left, Right) for alphabetical order
      const sortedFiles = designFiles.sort((a, b) => {
        const order = { 'Front': 0, 'Back': 1, 'Left': 2, 'Right': 3 };
        return order[a.position] - order[b.position];
      });

      this.global.pageLoading = true;
      
      // Use UploadDesignService with progress tracking
      this.uploadDesignService.uploadDesignFilesWithProgress(
        sortedFiles.map(df => ({ file: df.file, position: df.position })),
        (progress) => {
          this.sellerCheck.uploadProgress = progress;
        }
      ).then((result) => {
        this.sellerCheck.uploadProgress = null;
        this.global.pageLoading = false;
        this.sellerCheck.destinationProductLinkText = result.destinationProductLinkText;
        this.sellerCheck.destinationProductLinks = result.destinationProductLinks;
        this.sellerCheck.previewImages = result.previewImages;
        
        // Create the destination product link text with proper formatting
        //this.createDestinationProductLinkText(sortedFiles);
        
        this.toastr.success('Design files uploaded successfully!');
      }).catch((error) => {
        this.sellerCheck.uploadProgress = null;
        this.global.pageLoading = false;
        console.error('Upload error:', error);
        this.toastr.error('Failed to upload design files: ' + error.message);
      });
    }
  };

  createDestinationProductLinkText(sortedFiles: any[]) {
    // Create 4 rows for destinationProductLinkText
    const linkRows = ['', '', '', '']; // Initialize with empty strings
    
    // Map positions to row indices
    const positionToRow = { 'Front': 0, 'Back': 1, 'Left': 2, 'Right': 3 };
    
    // Fill in the rows with uploaded files
    sortedFiles.forEach((designFile, index) => {
      const rowIndex = positionToRow[designFile.position];
      const fileExtension = designFile.file.name.split('.').pop();
      const newFileName = `${String.fromCharCode(65 + index)}.${fileExtension}`;
      linkRows[rowIndex] = newFileName; // Use the renamed file name
    });
    
    // Join with newlines to create the final text
    this.sellerCheck.destinationProductLinkText = linkRows.join('\n');
  };

  createPreviewImagesFromLinks(demoLinks: string[]) {
    // Create preview images with labels from demo links
    this.temptPreviewImages = [];
    
    if (demoLinks && demoLinks.length > 0) {
      // Map demo links to positions (assuming order: Front, Back, Left, Right)
      const positions = ['Front', 'Back', 'Left', 'Right'];
      
      demoLinks.forEach((link, index) => {
        if (link && link.trim() !== '') {
          const previewWithLabel = {
            label: positions[index] || `Image ${index + 1}`,
            image: link,
            fileName: `Design ${index + 1}`
          };
          this.temptPreviewImages.push(previewWithLabel);
        }
      });
    }
  };

  createDestinationProductLinkTextFromServerResponse(res: any, sortedFiles: any[]) {
    // Create 4 rows for destinationProductLinkText using server response
    const linkRows = ['', '', '', '']; // Initialize with empty strings
    
    // Map positions to row indices
    const positionToRow = { 'Front': 0, 'Back': 1, 'Left': 2, 'Right': 3 };
    
    // Map server response links to positions based on file order
    if (res.destinationProductLinks && res.destinationProductLinks.length > 0) {
      sortedFiles.forEach((designFile, index) => {
        const rowIndex = positionToRow[designFile.position];
        if (res.destinationProductLinks[index]) {
          linkRows[rowIndex] = res.destinationProductLinks[index];
        }
      });
    }
    
    // Join with newlines to create the final text
    this.sellerCheck.destinationProductLinkText = linkRows.join('\n');
  };

  uploadToPublicServerWithCustomText(formData, files: any, customDestinationText: string, sortedFiles: any[]) {
    this.http
      .post("/api/SaleRecord/UploadDesign/", formData)
      .subscribe((res: any) => {
        this.sellerCheck.uploadProgress = null;
        this.global.pageLoading = false;
        
        // Create destinationProductLinkText with 4 rows using server response links
        this.createDestinationProductLinkTextFromServerResponse(res, sortedFiles);

        // Create preview images with labels from uploaded files
        this.temptPreviewImages = [];
        sortedFiles.forEach((designFile) => {
          if (designFile.file) {
            const reader = new FileReader();
            reader.onload = (event: any) => {
              // Create preview object with label and image
              const previewWithLabel = {
                label: designFile.position,
                image: event.target.result,
                fileName: designFile.file.name
              };
              this.temptPreviewImages.push(previewWithLabel);
            };
            reader.readAsDataURL(designFile.file);
          }
        });

        this.sellerCheck.selectedProduct = {
          demoLinks: res.previewImages
        };

        this.genDownloadLinks();
        this.desImages = '';
      },
        error => {
          alert('Có lỗi xảy ra, xin thử lại');
          this.sellerCheck.uploadProgress = null;
          this.global.pageLoading = false;
          this.desImages = '';
        });
  };

  passToSeller() {
    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;
    record.destinationProductLink = this.sellerCheck.destinationProductLinkText;
    record.note = this.sellerCheck.sourceProduct.note;
    record.destinationProductThumbnail = this.sellerCheck?.selectedProduct?.demoLinks.join('\n') ?? '';
    record.progressState = 0;

    this.saleRecordService.update(record).subscribe(data => {

      for (var i = 0; i < this.saleRecords.length; i++) {

        for (var j = 0; j < data.length; j++) {
          if (data[j].orderItemId != this.saleRecords[i].orderItemId) {
            continue;
          }
          this.saleRecords[i] = data[j];
        }
      }

      // Update the grouped data structure
      this.groupedSaleRecords = this.groupSaleRecordsByOrder(this.saleRecords);

      this.global.pageLoading = false;
      this.modalService.dismissAll();

      this.getFilterCount();
    });
  };

  passToNeedConfirm() {
    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;
    record.destinationProductLink = this.sellerCheck.destinationProductLinkText;
    record.note = this.sellerCheck.sourceProduct.note;
    record.destinationProductThumbnail = this.sellerCheck?.selectedProduct?.demoLinks.join('\n') ?? '';
    record.progressState = 5;

    this.saleRecordService.update(record).subscribe(data => {

      for (var i = 0; i < this.saleRecords.length; i++) {

        for (var j = 0; j < data.length; j++) {
          if (data[j].orderItemId != this.saleRecords[i].orderItemId) {
            continue;
          }
          this.saleRecords[i] = data[j];
        }
      }

      // Update the grouped data structure
      this.groupedSaleRecords = this.groupSaleRecordsByOrder(this.saleRecords);

      this.global.pageLoading = false;
      this.getFilterCount();
      this.modalService.dismissAll();
    });
  };

  passToDesigner() {
    if (this.sellerCheck.selectedDesigner == null) {
      return;
    }
    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;
    record.destinationProductLink = this.sellerCheck.destinationProductLinkText;
    record.note = this.sellerCheck.sourceProduct.note;
    record.destinationProductThumbnail = this.sellerCheck?.selectedProduct?.demoLinks.join('\n') ?? '';
    record.progressState = 10;
    record.selectedDesignerId = this.sellerCheck.selectedDesigner.id;
    record.desPoint = this.sellerCheck.sourceProduct.desPoint;

    this.saleRecordService.update(record).subscribe(data => {

      for (var i = 0; i < this.saleRecords.length; i++) {

        for (var j = 0; j < data.length; j++) {
          if (data[j].orderItemId != this.saleRecords[i].orderItemId) {
            continue;
          }
          this.saleRecords[i] = data[j];
        }
      }

      // Update the grouped data structure
      this.groupedSaleRecords = this.groupSaleRecordsByOrder(this.saleRecords);

      this.global.pageLoading = false;
      this.getFilterCount();
      this.modalService.dismissAll();
    });
  };

  passToFulfill() {
    if (this.sellerCheck.destinationProductLinkText == undefined || this.sellerCheck.destinationProductLinkText.trim() == '') {
      return;
    }

    if (this.timerRunning) {
      this.toastr.error('Bộ đếm thời gian vẫn đang chạy');
      return;
    }

    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;
    record.destinationProductLink = this.sellerCheck.destinationProductLinkText;
    record.note = this.sellerCheck.sourceProduct.note;
    record.desPoint = this.sellerCheck.sourceProduct.desPoint;
    if (this.sellerCheck.selectedProduct) {
      record.destinationProductThumbnail = this.sellerCheck.selectedProduct.demoLinks.join('\n');
    }

    record.progressState = 20;
    this.saleRecordService.update(record).subscribe(data => {
      this.refreshSaleRecordData(data);
    });
  };

  refreshSaleRecordData(data: any) {
    for (var i = 0; i < this.saleRecords.length; i++) {

      for (var j = 0; j < data.length; j++) {
        if (!data[j]) {
          this.toastr.error("Có lỗi xảy ra với đơn mua api");
          continue;
        }
        if (data[j].orderItemId != this.saleRecords[i].orderItemId) {
          continue;
        }
        this.saleRecords[i] = data[j];
      }
    }

    // Update the grouped data structure
    this.groupedSaleRecords = this.groupSaleRecordsByOrder(this.saleRecords);

    this.global.pageLoading = false;
    this.getFilterCount();
    this.modalService.dismissAll();
  }

  upload(files) {
    this.sellerCheck.uploadProgress = 1;
    const formData = new FormData();
    for (var i = 0; i < files.length; i++) {
      formData.append("file", files[i]);
    }

    this.global.pageLoading = true;

    this.uploadToPublicServer(formData, files);
  };

  uploadToPrivateServer(formData, files: any) {
    this.http.post("http://172.16.0.101/api/SaleRecord/UploadDesign/", formData)
      .subscribe((res: any) => {
        this.sellerCheck.uploadProgress = null;
        this.global.pageLoading = false;
        this.sellerCheck.destinationProductLinkText = res.destinationProductLinkText;

        this.temptPreviewImages = [];
        for (var previewIndex = 0; previewIndex < res.previewImages.length; previewIndex++) {
          var previewMess = res.previewImages[previewIndex];
          if (previewMess.indexOf('link cho file') === -1) {
            continue;
          }

          for (var orgFileIndex = 0; orgFileIndex < files.length; orgFileIndex++) {
            var orgFile = files[orgFileIndex];
            var fileName = orgFile.name;
            var fileNameFormPreviewMess = previewMess.split('/')[previewMess.split('/').length - 1];
            if (fileNameFormPreviewMess.toLowerCase() !== fileName.toLowerCase()) {
              continue;
            }
            var reader = new FileReader();

            reader.onload = (event: any) => {
              this.temptPreviewImages.push(event.target.result);
            }

            reader.readAsDataURL(files[orgFileIndex]);
          }
        }

        this.sellerCheck.selectedProduct = {
          demoLinks: res.previewImages
        };

        this.genDownloadLinks();
        this.desImages = '';
      },
        error => {
          alert('Có lỗi xảy ra, xin thử lại');
          this.sellerCheck.uploadProgress = null;
          this.global.pageLoading = false;
          this.desImages = '';
        });

  }

  uploadToPublicServer(formData, files: any) {
    this.http
      .post("/api/SaleRecord/UploadDesign/", formData)
      .subscribe((res: any) => {
        this.sellerCheck.uploadProgress = null;
        this.global.pageLoading = false;
        this.sellerCheck.destinationProductLinkText = res.destinationProductLinkText;

        this.temptPreviewImages = [];
        for (var previewIndex = 0; previewIndex < res.previewImages.length; previewIndex++) {
          var previewMess = res.previewImages[previewIndex];
          if (previewMess.indexOf('link cho file') === -1) {
            continue;
          }

          for (var orgFileIndex = 0; orgFileIndex < files.length; orgFileIndex++) {
            var orgFile = files[orgFileIndex];
            var fileName = orgFile.name;
            var fileNameFormPreviewMess = previewMess.split('/')[previewMess.split('/').length - 1];
            if (fileNameFormPreviewMess.toLowerCase() !== fileName.toLowerCase()) {
              continue;
            }
            var reader = new FileReader();

            reader.onload = (event: any) => {
              this.temptPreviewImages.push(event.target.result);
            }

            reader.readAsDataURL(files[orgFileIndex]);
          }
        }

        this.sellerCheck.selectedProduct = {
          demoLinks: res.previewImages
        };

        this.genDownloadLinks();
        this.desImages = '';
      },
        error => {
          alert('Có lỗi xảy ra, xin thử lại');
          this.sellerCheck.uploadProgress = null;
          this.global.pageLoading = false;
          this.desImages = '';
        });

  }

  genDownloadLinks() {
    this.sellerCheck.downloadLinks = [];
    var text = this.sellerCheck.destinationProductLinkText;
    if (text == undefined || text == '') {
      return;
    }
    var parts = text.split('\n');
    for (let i = 0; i < parts.length; i++) {
      const element = parts[i];
      var downloadLink = element.replace('raw=', 'dl=');
      this.sellerCheck.downloadLinks.push(downloadLink);
    }
  }

  getImageSizes() {
    var text = this.sellerCheck.destinationProductLinkText;
    this.sellerCheck.imageSizes = [];
    if (text == undefined || text == '') {
      return;
    }
    if (this.sellerCheck.sourceProduct.progressState != 20) {
      return;
    }
    var parts = text.replaceAll('\n', '###')
      .replaceAll(' ', '###');
    this.fulfillService.getImageSize(parts).subscribe(res => {
      this.sellerCheck.imageSizes = res;
    });

  }

  genSellerCheckCustomizeInfo(customization) {
    var result = [];
    for (let i = 1; i < 20; i++) {
      var customizeInfoPart = this.getCustomization(customization, i);
      if (customizeInfoPart != undefined && customizeInfoPart != '') {
        result.push(customizeInfoPart);
        continue;
      }
      break
    }
    return result.join(' | ');
  }

  syncSellerCheckPrice(record, type) {
    if (type == 'orderPrice' && record.orderPrice > 0) {
      record.productPrice = 0;
    }
    if (type == 'productPrice' && record.productPrice > 0) {
      record.orderPrice = 0;
    }

  }

  confirmBuy() {
    // if (this.sellerCheck.sourceProduct.destinationOrderId == undefined
    //   || this.sellerCheck.sourceProduct.destinationOrderId.trim() == ''
    //   || (this.sellerCheck.sourceProduct.productPrice == 0 && this.sellerCheck.sourceProduct.orderPrice == 0)) {
    //   return;
    // }
    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;

    record.note = this.sellerCheck.sourceProduct.note;
    record.destinationOrderId = this.sellerCheck.sourceProduct.destinationOrderId;
    record.destinationProductLink = this.sellerCheck.destinationProductLinkText;
    record.productPrice = this.sellerCheck.sourceProduct.productPrice;
    record.orderPrice = this.sellerCheck.sourceProduct.orderPrice;
    record.progressState = 30;

    this.saleRecordService.update(record).subscribe(data => {

      for (var i = 0; i < this.saleRecords.length; i++) {

        var model = _.find(data, o => o.orderItemId === this.saleRecords[i].orderItemId);
        if (model == undefined || model.length === 0) {
          continue;
        }
        this.saleRecords[i] = model;

      }

      // Update the grouped data structure
      this.groupedSaleRecords = this.groupSaleRecordsByOrder(this.saleRecords);

      this.global.pageLoading = false;
      this.getFilterCount();
      this.modalService.dismissAll();
    });
  }

  confirmTracking() {
    if (this.sellerCheck.sourceProduct.trackingNumber == 0) {
      return;
    }
    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;

    record.note = this.sellerCheck.sourceProduct.note;
    record.trackingNumber = this.sellerCheck.sourceProduct.trackingNumber;
    record.progressState = 35;

    this.saleRecordService.update(record).subscribe(data => {

      for (var i = 0; i < this.saleRecords.length; i++) {

        var model = _.find(data, o => o.orderItemId === this.saleRecords[i].orderItemId);
        if (model == undefined || model.length === 0) {
          continue;
        }
        this.saleRecords[i] = model;

      }

      // Update the grouped data structure
      this.groupedSaleRecords = this.groupSaleRecordsByOrder(this.saleRecords);

      this.global.pageLoading = false;
      this.getFilterCount();
      this.modalService.dismissAll();
    });
  }

  confirmTrackingAccount() {

    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;

    record.note = this.sellerCheck.sourceProduct.note;
    record.progressState = 40;

    this.saleRecordService.update(record).subscribe(data => {

      for (var i = 0; i < this.saleRecords.length; i++) {

        var model = _.find(data, o => o.orderItemId === this.saleRecords[i].orderItemId);
        if (model == undefined || model.length === 0) {
          continue;
        }
        this.saleRecords[i] = model;

      }

      // Update the grouped data structure
      this.groupedSaleRecords = this.groupSaleRecordsByOrder(this.saleRecords);

      this.global.pageLoading = false;
      this.getFilterCount();
      this.modalService.dismissAll();
    });
  }

  confirmTrackingDone() {
    if (this.sellerCheck.sourceProduct.trackingNumber == 0) {
      return;
    }
    var record = this.sellerCheck.currentRecord;

    this.global.pageLoading = true;

    record.note = this.sellerCheck.sourceProduct.note;
    record.progressState = 50;

    this.saleRecordService.update(record).subscribe(data => {

      for (var i = 0; i < this.saleRecords.length; i++) {

        var model = _.find(data, o => o.orderItemId === this.saleRecords[i].orderItemId);
        if (model == undefined || model.length === 0) {
          continue;
        }
        this.saleRecords[i] = model;

      }

      // Update the grouped data structure
      this.groupedSaleRecords = this.groupSaleRecordsByOrder(this.saleRecords);

      this.global.pageLoading = false;
      this.getFilterCount();
      this.modalService.dismissAll();
    });
  }

  updatePrintService(orderItemId, wantedPrintService) {
    this.saleRecordService.updatePrintService(orderItemId, wantedPrintService)
      .subscribe(data => {
        for (var i = 0; i < this.saleRecords.length; i++) {

          if (orderItemId != this.saleRecords[i].orderItemId) {
            continue;
          }
          this.saleRecords[i].wantedPrintService = wantedPrintService;
        }

        // Update the grouped data structure
        this.groupedSaleRecords = this.groupSaleRecordsByOrder(this.saleRecords);
      }
        , error => {
          this.toastr.error("Có lỗi xảy ra khi cập nhật thông tin đơn hàng, xin vui lòng báo cho Admin");
        });
  }

  updateVariantInfo(orderItemId, type, value) {
    this.getAvailablePrintWayPlaces();
    this.saleRecordService.updateVariantInfo(orderItemId, type, value)
      .subscribe(data => {
        for (var i = 0; i < this.saleRecords.length; i++) {

          if (orderItemId != this.saleRecords[i].orderItemId) {
            continue;
          }

          this.saleRecords[i].customizeInfo = data;
        }

        // Update the grouped data structure
        this.groupedSaleRecords = this.groupSaleRecordsByOrder(this.saleRecords);
      }
        , error => {
          this.toastr.error("Có lỗi xảy ra khi cập nhật thông tin đơn hàng, xin vui lòng báo cho Admin");
        });
  }

  onLenfulProductChange(product) {
    console.log('onLenfulProductChange called with:', product, 'type:', typeof product);
    if (product) {
      // Handle both string ID and object with id property
      let productIdString;
      if (typeof product === 'string') {
        productIdString = product;
      } else if (product && product.id) {
        productIdString = String(product.id);
      } else {
        console.error('Invalid product format:', product);
        return;
      }
      
      console.log('Converted to string:', productIdString);
      this.updateVariantInfo(this.sellerCheck.sourceProduct.orderItemId, 'LenfulProduct', productIdString);
      this.loadLenfulVariations(productIdString);
    } else {
      this.availableLenfulVariations = [];
      this.sellerCheck.calculatedLenfulVariationId = null;
    }
  }

  loadLenfulVariations(productId) {
    // Ensure productId is a string
    const productIdString = String(productId);
    this.saleRecordService.getLenfulProductVariations(productIdString).subscribe(data => {
      this.availableLenfulVariations = data.variants || [];
      
      // Only reset the variation selection if we're loading variations for a new product
      // If this is called from loadLenfulProductsAndVariations, preserve existing selection
      if (!this.sellerCheck.calculatedLenfulVariationId) {
        this.sellerCheck.calculatedLenfulVariationId = null;
      }
    }, error => {
      this.toastr.error("Có lỗi xảy ra khi tải danh sách biến thể Lenful");
    });
  }

  loadLenfulProducts() {
    this.saleRecordService.getLenfulProducts().subscribe(data => {
      this.availableLenfulProducts = data || [];
    }, error => {
      this.toastr.error("Có lỗi xảy ra khi tải danh sách sản phẩm Lenful");
    });
  }

  loadLenfulProductsAndVariations() {
    // Load Lenful products first
    this.saleRecordService.getLenfulProducts().subscribe(data => {
      this.availableLenfulProducts = data || [];
      
      // If there's already a selected Lenful product, load its variations
      if (this.sellerCheck.calculatedLenfulProductId) {
        this.loadLenfulVariations(this.sellerCheck.calculatedLenfulProductId);
      }
    }, error => {
      this.toastr.error("Có lỗi xảy ra khi tải danh sách sản phẩm Lenful");
    });
  }

  getBlueprints() {
    this.fulfillService.getBlueprints().subscribe(data => {
      this.blueprints = data;
    });
  }

  getPrintifyProviders(blueprintId: number) {
    if (!blueprintId) return;
    this.fulfillService.getPrintifyProviders(blueprintId).subscribe(data => {
      this.printifyProviders = data;
    });
  }

  ignoreDes(suggestProduct) {
    suggestProduct.ignoredDes = true;
    this.saleRecordService.ignoreDes(suggestProduct.orderItemId, this.sellerCheck.sourceProduct.sku).subscribe(data => { });
  }

  ignoreDesTotally() {
    this.preparedIgnoreProduct.ignoredDes = true;
    this.saleRecordService.ignoreDesTotally(this.preparedIgnoreProduct.orderItemId).subscribe(data => { });
  }

  confirmIgnoreDesTotally(suggestProduct) {
    this.preparedIgnoreProduct = suggestProduct;
    this.openConfirmAction.emit(suggestProduct);
  }

  preCheckConfirmDesWork(record) {
    this.global.pageLoading = true;
    this.saleRecordService.checkIfValidToStartDes(record).subscribe(data => {
      if (!data) {
        this.global.pageLoading = false;
        this.openConfirmStartDesModal.emit();
      } else {
        this.confirmDesWork();
      }
    });
  }

  confirmDesWork() {
    this.global.pageLoading = true;
    this.saleRecordService.confirmDesWork(this.sellerCheck.currentRecord).subscribe(data => {
      this.toastr.success('Bạn đã xác nhận làm việc trên Des này');

      this.global.pageLoading = false;
    });
  }

  //Seller Check => End

  groupByPrintway(item) {
    return item.group;
  }

  buyPrintifyByApi() {

    this.global.pageLoading = true;
    this.fulfillService.sendOrderPrintifyApi(this.sellerCheck.currentRecord).subscribe(data => {
      this.toastr.success('Đặt hàng thành công');
      this.refreshSaleRecordData(data);
      this.modalService.dismissAll();
      this.global.pageLoading = false;
    },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  buyFlashshipByApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderFlashshipApi([this.sellerCheck.currentRecord]).subscribe(data => {
      this.toastr.success('Đặt hàng thành công');
      this.refreshSaleRecordData(data);
      this.modalService.dismissAll();
      this.global.pageLoading = false;

      this.handleAfterSubmitApiOrders(data, 'flashship');

    },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  buyBeefulApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderBeefulApi([this.sellerCheck.currentRecord]).subscribe(data => {
      this.toastr.success('Đặt hàng thành công');
      this.refreshSaleRecordData(data);
      this.modalService.dismissAll();
      this.global.pageLoading = false;

      this.handleAfterSubmitApiOrders(data, 'beeful');

    },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  buyPrintwayByApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderPrintwayApi([this.sellerCheck.currentRecord]).subscribe(data => {
      this.toastr.success('Đặt hàng thành công');
      this.refreshSaleRecordData(data);
      this.modalService.dismissAll();
      this.global.pageLoading = false;

      this.handleAfterSubmitApiOrders(data, 'printway');

    },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  buyPrintCareByApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderBestPrintCareApi([this.sellerCheck.currentRecord]).subscribe(data => {
      this.toastr.success('Đặt hàng thành công');
      this.refreshSaleRecordData(data);
      this.modalService.dismissAll();
      this.global.pageLoading = false;
    },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  buyBurgerPrintByApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderBurgerPrintApi([this.sellerCheck.currentRecord]).subscribe(data => {
      this.toastr.success('Đặt hàng thành công');
      this.refreshSaleRecordData(data);
      this.modalService.dismissAll();
      this.global.pageLoading = false;

      this.handleAfterSubmitApiOrders(data, 'burgerprint');

    },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  buyLenfulByApi() {
    this.global.pageLoading = true;
    this.sellerCheck.currentRecord.isSelected = true;
    this.fulfillService.sendOrderLenfulApi([this.sellerCheck.currentRecord]).subscribe(data => {
      this.toastr.success('Đặt hàng thành công');
      this.refreshSaleRecordData(data);
      this.modalService.dismissAll();
      this.global.pageLoading = false;

      this.handleAfterSubmitApiOrders(data, 'lenful');

    },
      error => {
        this.toastr.error(error.message);
        this.global.pageLoading = false;
      });
  }

  openImportSaleRecordTiktokModal() {
    this.uploadImportFileProgress = 0;
    this.importMessages = [];
    this.uploadToMerchantGroupId = '';

    if (this.merchantGroups.length == 1) {
      this.uploadToMerchantGroupId = this.merchantGroups[0].id;
    }

    this.modalService.open(this.importSaleRecordTiktokModal, { windowClass: "xlModal" });

  }

  recalculateDesPoint(event) {
    this.global.pageLoading = true;
    this.logTimeService.calculateDesPoint(this.sellerCheck.currentRecord.orderItemId, 'Design')
      .subscribe(data => {
        this.sellerCheck.sourceProduct.desPoint = data;
        this.updateSingleValue(this.sellerCheck.sourceProduct, 'DesPoint', data);

        this.global.pageLoading = false;
      });
  }

  assignTimerRunning(event) {
    this.timerRunning = (event == "true");
  }

  addNewColor = (newColor) => {
    this.global.pageLoading = true;
    this.fulfillService.addColor(newColor)
      .subscribe(i => {
        this.global.pageLoading = false;
      });

    return newColor;
  }

  addNewSize = (newSize) => {
    this.global.pageLoading = true;
    this.fulfillService.addSize(newSize)
      .subscribe(i => {
        this.global.pageLoading = false;
      });

    return newSize;
  }

  getAvailablePrintLogistics() {
    this.fulfillService.getAvailablePrintLogistics()
      .subscribe(data => {
        this.printLogisticProducts = data;
      });
  }

  getBurgerPrintProducts() {
    this.fulfillService.getBurgerPrintProducts()
      .subscribe(data => {
        this.burgerPrintProducts = data;
      });
  }

  onMergeOrderCompleted() {
    // Refresh the sale records and merge suggestions
    this.querySaleRecords();
  }

  onReOrderCompleted() {
    // Refresh the sale records after reorder
    this.querySaleRecords();
  }

  imagePopupVisible = false;
  imagePopupSrc = '';

  showImagePopup(event: MouseEvent, imageSrc: string) {
    event.stopPropagation();
    this.imagePopupSrc = imageSrc;
    this.imagePopupVisible = true;
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
  }

  hideImagePopup() {
    this.imagePopupVisible = false;
    this.imagePopupSrc = '';
    // Restore body scroll when modal is closed
    document.body.style.overflow = '';
  }

  loadAvailableDesigners(orderItemId: string) {
    this.isLoadingDesigners = true;
    this.saleRecordService.getAvailableDesigners(orderItemId).subscribe(
      designers => {
        this.sellerCheck.availableDesigners = designers;
        
        // Auto-select first designer if none selected
        if ((this.sellerCheck.selectedDesigner == null || this.sellerCheck.selectedDesigner == undefined) && 
            this.sellerCheck.availableDesigners.length > 0) {
          this.sellerCheck.selectedDesigner = this.sellerCheck.availableDesigners[0];
        }
        this.isLoadingDesigners = false;
      },
      error => {
        this.toastr.error('Error loading available designers: ' + (error.error?.message || 'Unknown error'));
        this.sellerCheck.availableDesigners = [];
        this.isLoadingDesigners = false;
      }
    );
  }
}

